import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import protectedAxios from "../../common/axios";
import { API_URL } from "../../common/constants";

export default function ApplicationProcessingPartnerConsent() {
  const [leadDetails, setLeadDetails] = useState(null);
  const location = useLocation();
  const query = useQuery();

  function useQuery() {
    return new URLSearchParams(location.search);
  }

  const fetchLeadDetails = async (leadId) => {
    try {
      const { data } = await protectedAxios.get(
        `${API_URL}/v1/argonaut/lead/profile/${leadId}`
      );

      setLeadDetails(data);
    } catch (error) {
      Sentry.captureException(error);
      window.alert("Please try again later!");
    }
  };

  const updateLeadProfile = async (leadId) => {
    try {
      await protectedAxios.patch(
        `${API_URL}/v1/argonaut/lead/profile/${leadId}`,
        { metadata: { has_provided_consent: true } }
      );

      toast.success("Thanks! We have received your response.");
      window.location.reload();
    } catch (error) {
      Sentry.captureException(error);
      window.alert("Please try again later!");
    }
  };

  useEffect(() => {
    fetchLeadDetails(query.get("id"));
  }, [query]);

  const handleSubmit = () => {
    updateLeadProfile(query.get("id"));
  };

  return (
    <div className="py-12">
      {!leadDetails ? (
        <p>Loading ... </p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="space-y-12">
            <div className="pb-12 border-b border-gray-900/10">
              <h2 className="text-base font-semibold leading-7 text-gray-900">
                Consent Form for {leadDetails.full_name}
              </h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                We are excited to assist you in your pursuit of studying abroad
                and appreciate your trust in us to be your study abroad
                application processing partner. Before we proceed, we require
                your consent to process your application and handle the
                necessary steps to facilitate your study abroad journey. Please
                carefully review the terms and conditions outlined below and
                signify your agreement by clicking the "Accept" button at the
                end of this page. If you have any questions or concerns, feel
                free to reach out to our support team. <br /> <br />
                <input type="checkbox" name="" id="" checked disabled /> &nbsp;
                <a
                  href="https://nbyula.com/terms"
                  target="_blank"
                  rel="noreferrer"
                  className="text-link"
                >
                  Read the Terms & Conditions{" "}
                </a>
              </p>
            </div>
          </div>

          <div className="flex items-start justify-start mt-6 gap-x-6">
            <button
              type="button"
              onClick={() => {
                handleSubmit();
              }}
              disabled={leadDetails.metadata.has_provided_consent}
              className="block float-left w-full px-3 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-md shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:bg-indigo-500 disabled:bg-gray-500"
            >
              {leadDetails.metadata.has_provided_consent
                ? "Accepted"
                : "Accept"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
